import { useEffect } from 'react';
import { useSite } from '../content';

/**
 * Injects raw meta tag HTML from Sanity site settings directly into <head>.
 * Cleans up previous injections on update so tags stay in sync with the CMS.
 */
export function HeadMetaTags() {
  const { site } = useSite();

  useEffect(() => {
    if (!site.rawMetaTags) return;

    // Create a temporary container to parse the HTML string
    const temp = document.createElement('div');
    temp.innerHTML = site.rawMetaTags;

    // Remove previously injected meta tags
    document.head.querySelectorAll('[data-sanity-meta]').forEach((el) => el.remove());

    // Inject each element into <head>
    Array.from(temp.children).forEach((node) => {
      const el = node.cloneNode(true) as HTMLElement;
      el.setAttribute('data-sanity-meta', '');
      document.head.appendChild(el);
    });

    return () => {
      document.head.querySelectorAll('[data-sanity-meta]').forEach((el) => el.remove());
    };
  }, [site.rawMetaTags]);

  return null;
}
